<template>
    <div class="top_con">
       <el-form :inline="true" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="搜索内容">
                    <el-input v-model="search_cont"  placeholder="请输入姓名或者岗位类别"></el-input>
                </el-form-item>
                <el-form-item label="来源">
                        <el-select v-model="source_desc" placeholder="请选择"  >
                            <el-option label="后台" :value="1" ></el-option>
                            <el-option label="小程序" :value="2" ></el-option>
                        </el-select>
                    </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <iframe id="daochu" style="display:none;" src='about:blank'></iframe>
        <form target="daochu" id="myForm" style="display:none;" action="https://hmd.18durensheng.com/admin_mingdan/exportIndexRed.html" method="post" >
            <el-input placeholder="Search" name="searchCont"  v-model="search_cont" size="small" class="input1"></el-input>
        </form>
        <el-button type="primary" @click="daochu" style="margin-top:20px;" v-if="true1==true">导出</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" @selection-change="handleSelectionChange" max-height="600px">
            <el-table-column  prop="id"  label="ID"></el-table-column>
            <el-table-column  prop="gangwei"  label="岗位类别"></el-table-column>
            <el-table-column prop="name"  label="姓名"></el-table-column>
            <el-table-column prop="zhiwei"  label="地点" ></el-table-column>
            <el-table-column prop="num"  label="上榜人照片" >
                <template slot-scope="scope">
                    <el-image  style="width:40px;height:30px;margin:0 auto;" :src="scope.row.img" :preview-src-list="scope.row.imgs"></el-image>
                 </template>
            </el-table-column>
            <el-table-column prop="zcost"  label="作品链接" >
                <template slot-scope="scope">
                    <el-link type="primary" @click="look(1,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="dcost"  label="推荐理由" >
                <template slot-scope="scope">
                <el-link type="primary" @click="look(2,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="referrer"  label="推荐人" ></el-table-column>
            <el-table-column prop="reguser"  label="注册人" ></el-table-column>
            <el-table-column prop="sprice"  label="评审">
                <template slot-scope="scope">
                <el-link type="primary" @click="look(3,scope.row)">查看</el-link>
                </template>
            </el-table-column>
             <el-table-column prop="source_desc"  label="来源" ></el-table-column>
            <el-table-column   label="操作" style="text-align:center"> 
                <template slot-scope="scope">
                    <el-link :underline="false" @click="add_md(3,scope.row.id)" style="margin-right:20px;" size="small" v-if="true2==true">编辑</el-link>
                    <el-link :underline="false" type="primary" @click="ps_New(scope.row.id)" size="small" v-if="true3==true && scope.row.repf==1">重新评审</el-link>
                    <el-link :underline="false" type="danger" @click="delOne(scope.row.id)" size="small" v-if="true3==true">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="36%">
                <el-input v-model="cknum" :disabled="true" v-if="tit_type==1"></el-input>
                <div class="wenzi" v-else-if="tit_type==2" v-html="jianjie"></div>
                <div class="wenzi2" v-else-if="tit_type==3">
                     <el-table  ref="multipleTable" :data="ps.list" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  max-height="300px">
                        <el-table-column prop="hangye"  label="沟通能力"></el-table-column>
                        <el-table-column prop="xingjiabi" label="创意能力"></el-table-column>
                        <el-table-column prop="koucai" label="项目投入度"></el-table-column>
                        <el-table-column prop="zuopin"  label="时间观念" ></el-table-column>
                        <el-table-column prop="qita"  label="制作配合度" ></el-table-column>
                        <el-table-column prop="avg"  label="平均分" ></el-table-column>
                        <el-table-column prop="username"  label="评审人"></el-table-column>
                    </el-table>
                     <p style="padding-left:30px;">评分结果：{{ps.avg}}</p>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="dialogFormVisible = false">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog title="重新评审" :visible.sync="dialogFormVisible_s" width="44%">
                <div class="wenzi2">
                    <el-button type="primary" @click="add_pf()" style="margin-top:0px;">添加</el-button>
                    <el-table  ref="multipleTable" :data="ps" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="300px">
                        <el-table-column   label="沟通能力">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.hangye" class="select2" placeholder="select" size="mini" @change="edit(scope.$index, ps)">
                                    <el-option key="0" label="0" value="0"></el-option>
                                    <el-option key="1" label="1" value="1"></el-option>
                                    <el-option key="2" label="2" value="2"></el-option>
                                    <el-option key="3" label="3" value="3"></el-option>
                                    <el-option key="4" label="4" value="4"></el-option>
                                    <el-option key="5" label="5" value="5"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column   label="创意能力">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.xingjiabi" class="select2" placeholder="select" size="mini" @change="edit(scope.$index, ps)">
                                    <el-option key="0" label="0" value="0"></el-option>
                                    <el-option key="1" label="1" value="1"></el-option>
                                    <el-option key="2" label="2" value="2"></el-option>
                                    <el-option key="3" label="3" value="3"></el-option>
                                    <el-option key="4" label="4" value="4"></el-option>
                                    <el-option key="5" label="5" value="5"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column   label="项目投入度">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.koucai" class="select2" placeholder="select" size="mini" @change="edit(scope.$index, ps)">
                                    <el-option key="0" label="0" value="0"></el-option>
                                    <el-option key="1" label="1" value="1"></el-option>
                                    <el-option key="2" label="2" value="2"></el-option>
                                    <el-option key="3" label="3" value="3"></el-option>
                                    <el-option key="4" label="4" value="4"></el-option>
                                    <el-option key="5" label="5" value="5"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price"  label="时间观念" >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.zuopin" class="select2" placeholder="select" size="mini" @change="edit(scope.$index, ps)">
                                    <el-option key="0" label="0" value="0"></el-option>
                                    <el-option key="1" label="1" value="1"></el-option>
                                    <el-option key="2" label="2" value="2"></el-option>
                                    <el-option key="3" label="3" value="3"></el-option>
                                    <el-option key="4" label="4" value="4"></el-option>
                                    <el-option key="5" label="5" value="5"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="num"  label="制作配合度" >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.qita" class="select2" placeholder="select" size="mini" @change="edit(scope.$index, ps)">
                                    <el-option key="0" label="0" value="0"></el-option>
                                    <el-option key="1" label="1" value="1"></el-option>
                                    <el-option key="2" label="2" value="2"></el-option>
                                    <el-option key="3" label="3" value="3"></el-option>
                                    <el-option key="4" label="4" value="4"></el-option>
                                    <el-option key="5" label="5" value="5"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="avg"  label="平均分" ></el-table-column>
                        <el-table-column prop="username"  label="评审人"></el-table-column>
                        <el-table-column label="操作" >
                        <template slot-scope="scope">
                                <el-link :underline="false" type="danger" @click="del(scope.$index, ps)" size="small">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="onEdit">确认修改</el-button>
                    <el-button  @click="dialogFormVisible_s = false">取消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {getHList,getList_ps,getHList_ps,CkC,getList_del} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            houseLis:[],
            ckid:'',
            cknum:'',
            ps:[],
            ruKu:'',
            jieYu:'',
            zMoney:'',
            search_cont:'',
            jianjie:'',
            dialogFormVisible:false,
            dialogFormVisible_s:false,
            chuKu:false,
            zp_tit:"作品链接",
            tit_type:0,
            formLabelWidth: '120px',
            value:10,
            source_desc:'',
            total:12,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            pageNum:1,
            true1:false,
            true2:false,
            true3:false,
            psid:'',
            avg:0
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                searchCont:this.search_cont,
                source_desc:this.source_desc
            }
            getHList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
                if(res.qx.indexOf('1')!=-1){
                    this.true1=true;
                }
                if(res.qx.indexOf('2')!=-1){
                    this.true2=true;
                }
                if(res.qx.indexOf('3')!=-1){
                    this.true3=true;
                }
            });
        },
        add_md(idx,id){
            this.$router.push({
                path:'/NameList',
                query:{
                    idx:idx,
                    id:id
                }
            })
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:'1',
                searchCont:this.search_cont,
                source_desc:this.source_desc
            }
            getHList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        look(idx,row){
            this.dialogFormVisible=true
            if(idx==1){
                this.zp_tit="作品链接";
                this.tit_type=1;
                this.cknum=row.link
            }else if(idx==2){
                this.zp_tit="推荐理由";
                this.tit_type=2;
                this.jianjie=row.intro
            }else if(idx==3){
                this.zp_tit="评审";
                this.tit_type=3;
                getList_ps({id:row.id}).then(res=>{
                   this.ps=res;
                })
            }
        },
        ps_New(id){
            this.dialogFormVisible_s=true;
            this.psid=id;
                getList_ps({id:id}).then(res=>{
                   this.ps=res.list;
                   this.avg=res.avg
                })
                console.log(this.ps)
        },
        edit(index, rows){
            rows[index].avg=(Number(rows[index].hangye)+Number(rows[index].xingjiabi)+Number(rows[index].koucai)+Number(rows[index].zuopin)+Number(rows[index].qita))/5
        },
        add_pf(){
            this.ps.push({id:'',hangye:0,xingjiabi:0,koucai:0,zuopin:0,qita:0,username:this.user.name})
        },
        del(index, rows){
           rows.splice(index, 1);
        //    if(rows.length<5){
        //        this.form.avg=0
        //    }
        },
        delOne(id){
            this.$confirm('确定删除, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:user.uid,
                        id:id
                    }
                    getList_del(param).then(res=>{
                        console.log(res)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        getHList(param).then(res=>{
                            this.total=res.total,
                            this.tableData=res.list
                        });
                    });
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        war(id){
            this.chuKu=true;
            this.ckid=id
        },
        subCk(){
            let user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userid:user.uid,
                id:this.ckid,
                num:this.cknum
            }
            CkC(param).then(res=>{
                this.chuKu=false;
                getHList(param).then(res=>{
                    this.total=res.total
                    this.tableData=res.list
                })
            })
        },
        clearS(){
            this.search_cont=''
            getHList().then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        onEdit(){
            let param ={
                userId:this.user.uid,
                forms:this.ps,
                id:this.psid
            }
            getHList_ps(param).then(res=>{
                this.dialogFormVisible_s=false;
                getHList().then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                })
            })
        },
        daochu(){
            document.getElementById("myForm").submit();
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            numPerPage:this.value,
            pageNum:this.pageNum,
            searchCont:this.search_cont,
            source_desc:this.source_desc
        }
        getHList(param).then(res=>{
            this.total=res.total,
            this.tableData=res.list
            if(res.qx.indexOf('1')!=-1){
                this.true1=true;
            }
            if(res.qx.indexOf('2')!=-1){
                this.true2=true;
            }
            if(res.qx.indexOf('3')!=-1){
                this.true3=true;
            }
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
    .wenzi{
        width:100%;
        height:100px;
        border:2px solid #e5e5e5;
    }
    table{
        margin:0 auto;
        width:100%;
        margin: 0;
    }
    table,table tr td {
            border: 1px solid #DEDEDE;
            margin: 0;
            color: #000000;
            padding: 10px 10px;
            box-sizing:border-box;
            font-size: 14px;
            font-weight: 400;
			font-family: Microsoft YaHei;
            border-collapse: collapse;
            text-align:center;
        }
</style>



// WEBPACK FOOTER //
// src/components/Warehouse.vue